import { Box, Tabs, Tab } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store/hooks/hooks';
import AdminApi from '../../../store/services/admin';
import Loading from '../../../utils/loading/loading';
import RequestTable from '../requestTable/requestTable';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <>{children}</>
                </Box>
            )}
        </div>
    );
}


const RequestTab = (props:any) => {
    const [status, setStatus] = useState(0);
    const [results, setResults] = useState<any>([])
    const [loading, setloading] = useState(true)
    const userDetails = useAppSelector((state: any) => state.user.user)
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setStatus(newValue);
    };
    const fetchRequest = () => {
        setloading(true)
        AdminApi.getRequests(status + "").then(res => {
            setloading(false)
            let resultItems = []
            for (let elm of res) {
                for (let req of elm.request) {
                    let requestObj = {
                        Student: {
                            name: `${elm.user.first_name} ${elm.user.last_name}`,
                            studentId: elm.user.Student_ID
                        },
                        Status: req.Status,
                        DateSubmitted: req.details.dateApplied,
                        PlacementId: elm.placement.Id,
                        details: req.details,
                        code: req.requestCode,
                        id:req._id
                    }
                    resultItems.push(requestObj)
                }
            }
             setResults([...resultItems])
        })

    }
    useEffect(() => {
        if (status !== -1) {
            fetchRequest()
        }
    }, [status])
    useEffect(() => {
        setStatus(0)
    }, [])
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
                <Tabs value={status} onChange={handleChange} centered>
                    <Tab label="Pending" />
                    <Tab label="Aproved" />
                    <Tab label="Rejected" />
                </Tabs>
            </Box>
            {
                loading ? <>
                    <Loading message="Requests"></Loading>
                </> :
                    <>
                        <TabPanel value={status} index={0}>
                            {
                                <RequestTable results={results.sort((a:any,b:any) => new Date(a.details.dateApplied) > new Date(b.details.dateApplied) ? -1 : 1)} approver={userDetails} changeStatus={() => {
                                    fetchRequest()
                                }}></RequestTable>
                            }

                        </TabPanel>
                        <TabPanel value={status} index={1}>
                            {
                                <RequestTable results={results.sort((a:any,b:any) => new Date(a.details.dateApplied) > new Date(b.details.dateApplied) ? -1 : 1)} approver={userDetails} changeStatus={() => {
                                    fetchRequest()
                                }}></RequestTable>
                            }
                        </TabPanel>
                        <TabPanel value={status} index={2}>
                            {
                                <RequestTable results={results.sort((a:any,b:any) => new Date(a.details.dateApplied) > new Date(b.details.dateApplied) ? -1 : 1)} approver={userDetails} changeStatus={() => {
                                    fetchRequest()
                                }}></RequestTable>
                            }
                        </TabPanel>
                    </>
            }
        </Box>

    );

}
export default RequestTab